import { APIClient } from "@surya-digital/tedwig";
import { AssignProjectToAPIKeyRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/assignProjectToApiKeyRPC";
import { AssignProjectToAPIKeyRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/assignProjectToApiKeyRPCClientImpl";
import { DeleteAPIKeyRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/deleteApiKeyRPC";
import { DeleteAPIKeyRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/deleteApiKeyRPCClientImpl";
import { GenerateNewAPIKeyRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/generateNewApiKeyRPC";
import { GenerateNewAPIKeyRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/generateNewApiKeyRPCClientImpl";
import { GetActiveProjectsForAPIKeyManagementRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/getActiveProjectsForApiKeyManagementRPC";
import { GetActiveProjectsForAPIKeyManagementRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/getActiveProjectsForApiKeyManagementRPCClientImpl";
import { GetProjectsByAPIKeyRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/getProjectsByApiKeyRPC";
import { GetProjectsByAPIKeyRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/getProjectsByApiKeyRPCClientImpl";
import { GetPublicAPIKeysRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/getPublicApiKeysRPC";
import { GetPublicAPIKeysRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/getPublicApiKeysRPCClientImpl";
import { InvalidateAndRotateAPIKeyRPC } from "@pulse/pulse-rpcs/lib/external-public-apis/invalidateAndRotateApiKeyRPC";
import { InvalidateAndRotateAPIKeyRPCClientImpl } from "@pulse/pulse-rpcs/lib/external-public-apis/invalidateAndRotateApiKeyRPCClientImpl";

export const getPublicAPIKeysRPCClient = (
  apiClient: APIClient,
): GetPublicAPIKeysRPC => new GetPublicAPIKeysRPCClientImpl(apiClient);

export const getActiveProjectsForAPIKeyManagementRPCClient = (
  apiClient: APIClient,
): GetActiveProjectsForAPIKeyManagementRPC =>
  new GetActiveProjectsForAPIKeyManagementRPCClientImpl(apiClient);

export const generateNewAPIKeyRPCClient = (
  apiClient: APIClient,
): GenerateNewAPIKeyRPC => new GenerateNewAPIKeyRPCClientImpl(apiClient);

export const assignProjectToAPIKeyRPCClient = (
  apiClient: APIClient,
): AssignProjectToAPIKeyRPC =>
  new AssignProjectToAPIKeyRPCClientImpl(apiClient);

export const getProjectsByAPIKeyRPCClient = (
  apiClient: APIClient,
): GetProjectsByAPIKeyRPC => new GetProjectsByAPIKeyRPCClientImpl(apiClient);

export const invalidateAndRotateAPIKeyRPCClient = (
  apiClient: APIClient,
): InvalidateAndRotateAPIKeyRPC =>
  new InvalidateAndRotateAPIKeyRPCClientImpl(apiClient);

export const deleteAPIKeyRPCClient = (apiClient: APIClient): DeleteAPIKeyRPC =>
  new DeleteAPIKeyRPCClientImpl(apiClient);
